import { ShopEffects } from './shop.effect';
import { ShopTemplateSetEffects } from './shop-template-set.effect';

export const effects: any[] = [ShopEffects, ShopTemplateSetEffects];

export * from './shop.effect';
export * from './shop-template-set.effect';
